import React, { useContext, useEffect } from 'react';
import CartContext from '../../../context/CartProvider';
// import Cart from './Cart'
import Icon from '../../atoms/Icon/Icon'
import Button from '../../atoms/Button/Button'

import * as styles from './Notification.module.css';

// TODO: Incomplete component - needs to be finished. Please update the readme when complete.

const NotificationOutput = ({ id, text, type }) => {
  const value = useContext(CartContext);
  const removeNotification = value && value.removeNotification;
  useEffect(() => {
    const timer = setTimeout(() => {
      removeNotification(id);
    }, 7000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, []);

  return (
    <article className={`${styles.notification} ${styles.animate}`}>
      <div className={styles.content}>
        <div className={styles.message}>
          <div className={styles.title}>
            <div className={styles.text}>
              Your Cart
            </div>
            <div className={styles.icon} role="presentation" onClick={() => removeNotification(id)}>
              <Icon symbol="close" />
            </div>
          </div>
          <div className={styles.messageWrapper}>
            <p>{text}</p>
          </div>
          {/* <Cart cartType="overlay" /> */}
          <div className={styles.actions}>
            <Button href="/confirm-order" level="primary" onClick={() => removeNotification(id)}>View Cart</Button>
          </div>
        </div>
      </div>
    </article>
  );
};

const Notification = () => {
  const value = useContext(CartContext);
  const notifications = value && value.notifications;
  const hasNotifications = Array.isArray(notifications) && notifications.length;

  return hasNotifications ? (
    <section className={styles.notify}>
      {notifications.map(note => (
        <NotificationOutput key={note.id} {...note} />
      ))}
    </section>
  ) : null;
};

export default Notification